import { Controller } from '@hotwired/stimulus'

// Browser zoom is a strong signal the teacher is projecting the preview to
// the class, so swap the preview banner for a nudge towards Present mode.
// Zoom changes have no event of their own; each change re-resolves the
// devicePixelRatio media query, firing `change` once, so re-arm every time.
export default class extends Controller {
  static targets = ['calm', 'nudge']
  static values = { threshold: { type: Number, default: 1.25 } }

  connect() {
    this.check = this.check.bind(this)
    this.baseline = window.devicePixelRatio
    this.arm()
  }

  disconnect() {
    this.media.removeEventListener('change', this.check)
  }

  arm() {
    this.media = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
    this.media.addEventListener('change', this.check, { once: true })
  }

  check() {
    const zoomed = window.devicePixelRatio >= this.baseline * this.thresholdValue
    this.calmTarget.hidden = zoomed
    this.nudgeTarget.hidden = !zoomed
    this.arm()
  }
}
